const routes = {
    ILLUSTRATIONS: 'illustrations',
    ICONS: 'icons',
    ANIMATED_ASSETS: 'animated-assets',
    TILE_LOGO: 'tile-logo',
    ASSETS: 'assets',
    EVENTS: 'events',
    REGIONS: 'regions',
    CREATE: 'create',
    UPDATE: 'update',
    LOGIN: 'login',
    HELP: 'help',
    USAGE_GUIDE: 'usage-guide',
    BCS_FLOW_GUIDE: 'bcs-flow',
    CONTACT_US: 'contact-us',
    ILLUSTRATION_BUILDER: 'illustration-builder',
    APP_IDS: 'app-ids',
    ADMINS: 'admins'
};

export default routes;
